import constants from "./constants";
import wx from 'weixin-js-sdk'
// 判断登录
export function jumpToLogin() {
	if (process.env.NODE_ENV === 'development') {
		location.href = constants.hostname + '/#/login/token?reURL=' + encodeURIComponent(location.href)
	} else if (process.env.NODE_ENV === 'test') {
		location.href =
			constants.hostname +
			'/h5/wx/login?app=gxxt&reURL=' +
			encodeURIComponent(location.href)
	} else {
		location.href =
			constants.hostname +
			'/h5/wx/login?app=gxxt&reURL=' +
			encodeURIComponent(location.href)
	}
}
//设置cookie
export function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + "; " + expires;
}
//获取cookie
export function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1);
		if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
	}
	return "";
}
//清除cookie  
export function clearCookie(name) {
	setCookie(name, "", -1);
}
// hh:mm:ss
export const secondsFormat = (value) => {
	let second = value,
		minute = 0,
		hour = 0;
	if (second >= 60) {
		minute += Math.floor(second / 60);
		second = Math.floor(second % 60);

	} else {
		second = Math.floor(second);
	}

	if (minute >= 60) {
		hour += Math.floor(minute / 60);
		minute = minute % 60;
	} else {
		minute = Math.floor(minute);
	}
	if (hour == 0) {
		return (minute > 9 ? minute : ("0" + minute)) +
			":" + (second > 9 ?
				second : ("0" + second))
	}
	return value = (hour > 9 ? hour : ("0" + hour)) + ":" + (minute > 9 ? minute : ("0" + minute)) +
		":" + (second > 9 ?
			second : ("0" + second))
}
// hh时mm分ss秒
export const secondsFormatCn = (value) => {
	let second = value,
		minute = 0,
		hour = 0;
	if (second >= 60) {
		minute += Math.floor(second / 60);
		second = Math.floor(second % 60);

	} else {
		second = Math.floor(second);
	}

	if (minute >= 60) {
		hour += Math.floor(minute / 60);
		minute = minute % 60;
	} else {
		minute = Math.floor(minute);
	}
	if (hour == 0) {
		return (minute > 9 ? minute : ("0" + minute)) +
			"分" + (second > 9 ?
				second : ("0" + second)) + '秒'
	}
	return value = (hour > 9 ? hour : ("0" + hour)) + "时" + (minute > 9 ? minute : ("0" + minute)) +
		"分" + (second > 9 ?
			second : ("0" + second)) + '秒'
}
export const timeLong = value => {
	let h = value / 1000 / 60 / 60;
	if (h < 100) {
		h = Math.ceil(h * 10) / 10;
	} else {
		h = Math.ceil(h);
	}
	return h;
}
//跳转页面
/**
领取完票券的h5页面------APP票券列表页（线下课赠送票劵）
领取完开课权益的h5页面-------- APP订单列表页（团购赠课）
课程简介h5页面-----2 APP课程目录页（线下课和团购）
课程购买成功h5页面-------1APP订单列表页（下载app）

jumpType   跳转类型（0：APP票券列表页  1：APP订单列表页  2：APP课程目录页）
当jumpType为2的时候必须传递resourceId和goodsType
*/
export const openApp = ({
	jumpType = null,
	resourceId = null,
	goodsType = null,
	goodsId = null,
} = {}) => {
	window.open(`https://download.bijixia.net/?jumpType=${jumpType}&resourceId=${resourceId}&goodsType=${goodsType}&goodsId=${goodsId}`)
}

export function getPlatForm() {
	var u = navigator.userAgent;
	var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
	var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

	if (isAndroid) {
		return 'Android'
	}
	if (isiOS) {
		return 'ios'
	}
}
//判断访问终端
export function browser() {
	var u = navigator.userAgent, app = navigator.appVersion;
	return {
		trident: u.indexOf('Trident') > -1, //IE内核
		presto: u.indexOf('Presto') > -1, //opera内核
		webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
		gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
		mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
		ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
		android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
		iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
		iPad: u.indexOf('iPad') > -1, //是否iPad
		webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
		weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
		qq: u.match(/\sQQ/i) == " qq" //是否QQ
	};
}

export function WxAndMobile() {
	let isMobile = false
	let isWx = getIsWxClient()
	let browserRes = browser()
	if (browserRes.mobile || browserRes.android || browserRes.ios) {
		isMobile = true
	}
	if (isWx && isMobile) {
		return true
	}
}

export function getIsWxClient() {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true;
	}
	return false;
}
//滚动条在Y轴上的滚动距离
export const getScrollTop = () => {
	let scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
	if (document.body) {
		bodyScrollTop = document.body.scrollTop;
	}
	if (document.documentElement) {
		documentScrollTop = document.documentElement.scrollTop;
	}
	scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
	return scrollTop;
}
//文档的总高度
export const getScrollHeight = () => {
	let scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
	if (document.body) {
		bodyScrollHeight = document.body.scrollHeight;
	}
	if (document.documentElement) {
		documentScrollHeight = document.documentElement.scrollHeight;
	}
	scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
	return scrollHeight;
}

//浏览器视口的高度
export const getWindowHeight = () => {
	let windowHeight = 0;
	if (document.compatMode === "CSS1Compat") {
		windowHeight = document.documentElement.clientHeight;
	} else {
		windowHeight = document.body.clientHeight;
	}
	return windowHeight;
}

export const getAppScrollHeight = () => {
	let scrollHeight = document.getElementById('app').scrollHeight
	return scrollHeight;
}
export const getAppScrollTop = () => {
	let scrollTop = document.getElementById('app').scrollTop
	return scrollTop;
}

export const jumpToService = () => {
	// 唤起小程序支付
	wx.miniProgram.navigateTo({
		url: '/pages/service/service'
	})
}